<template>
  <div class="content-container">
    <div v-if="callSubNav == 'call'">
      <div v-if="call_type == 'normal'">
        <incoming-call
          v-if="
            (call_state == 'INCOMING' ||
              call_state == 'CONNECTING' ||
              call_state == 'ACCEPTED') &&
              !outboundCall">
        </incoming-call>
        <normal-call
          v-if="
            (call_state == 'CONNECTED' || outboundCall) && call_state != 'ACW'
          "
        ></normal-call>
        <!-- <after-call-work
          v-if="call_state == 'ACW' || call_state == 'MISSED'"
        ></after-call-work> -->
      </div>

      <div v-if="call_type=='onlyThirdParty'">
        <OnThirdPartyConnected v-if="call_state!= 'ACW' || call_state !='MISSED'"></OnThirdPartyConnected>

        
      </div>
      <div>
        <after-call-work
          v-if="call_state == 'ACW' || call_state == 'MISSED'"
        ></after-call-work>

      </div>
      

      <!-- <after-call-work
          v-if="call_state == 'ACW' || call_state == 'MISSED' || call_state == 'onlyThirdPartyEnded'"
        ></after-call-work> -->
        <!-- <after-call-work
          v-if="call_state == 'ACW' || call_state == 'MISSED'"
        ></after-call-work> -->

      <div v-if="call_type == 'conference'">
        <conference-call> </conference-call>
      </div>
      <!-- <div v-if="call_state != 'MISSED' || call_state != 'CONNECTING'">
        <utilities style="margin-top: 5px"></utilities>
      </div> -->
      <!-- <utilities v-if="call_state != 'CONNECTING'"></utilities> -->
      <add-notes v-if="notes_editor == true"></add-notes>

      <!-- <dialer-switch v-if="number_pad == true"></dialer-switch> -->

      <!-- 
      <div class="call-handle-buttons-container">
    
          <b-col>
            <b-button size="sm" v-if="call_state == 'CONNECTED' || call_state == 'ACW'" variant="success" style="margin-left: 100px;" @click="redirectFcrmContact()">View Contact</b-button>
          </b-col>
          <b-col>
            <b-button size="sm" v-if="call_state == 'CONNECTED' || call_state == 'ACW'" variant="success"  @click="redirectFcrmContact()">View Contact</b-button>
          </b-col>
       
      </div> -->

      <div
        style="display: grid; grid-template-columns: repeat(2, 100fr); gap: 5px;    margin-top: 330px;"
        v-if="
          call_state == 'CONNECTED' ||
            call_state == 'ACW' ||
            (call_state != outboundCall && call_state != 'CONNECTING')
        "
      >
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="redirectFcrmContact()"
        >
          <font-awesome-icon icon="user" size="sm" />
          <span> View Contact </span>
        </b-button>

        <b-button
          size="sm"
          variant="outline-secondary"
         
          @click="redirectFcrmConversation()"
        >
          <font-awesome-icon icon="comment" size="sm" />
          <span> View Conversation </span>
        </b-button>
      </div>
      <div v-else-if="call_state == 'CONNECTING'">
        <b-button
          size="sm"
          variant="outline-secondary"
          style="margin-top: 320px; width: 100%"
          @click="redirectFcrmContact()"
        >
          <font-awesome-icon icon="user" size="sm" />
          <span> View Contact </span>
        </b-button>
      </div>
      <div v-if="call_state == 'CONNECTED' || call_state == 'ACW'">
        <!-- <b-card no-body>
      <b-tabs v-model="tabIndex" small card>
        <b-tab title="Add Notes">
              <add-notes ></add-notes>
        </b-tab>
        <b-tab title="Contact Info">
          <b-card>
            <b-button size="sm"  variant="outline-secondary" style="width: 100%;"  @click="redirectFcrmContact()">View Contact</b-button>
            <b-button size="sm" variant="outline-secondary"  style="width: 100%; margin-top: 10px;" @click="redirectFcrmConversation()">View Conversation</b-button>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card> -->
        <!-- <div style="margin-top:0px;">
          <b-card no-body>
            <b-tabs small card end>
              <b-tab title="Add Notes" active>
                  <b-card-text>
                    <add-notes ></add-notes>
                  </b-card-text>
               </b-tab>
              <b-tab title="Tab 2"><b-card-text>Tab contents 2</b-card-text></b-tab>
            </b-tabs>
          </b-card>
        </div> -->
      </div>

      <!--     
      <div>
        <b-list-group  v-if="call_state == 'CONNECTED' || call_state == 'ACW'">
          <b-list-group-item>
            <b-button size="sm"  variant="info" style="width: 100%;"  @click="redirectFcrmContact()">View Contact</b-button>
          </b-list-group-item>
          <b-list-group-item>
            <b-button size="sm" variant="info" style="width: 100%;"  @click="redirectFcrmConversation()">View Conversation</b-button>
          </b-list-group-item>
        </b-list-group>
      </div> -->

      <!-- <div v-if="caller_name == 'Unknown Caller'">
        <create-contact style="margin-top: 5px"></create-contact>
      </div> -->
    </div>

    <div v-if="callSubNav == 'dialpad'">
      <!-- <dialer></dialer>  -->
      <dialer-switch></dialer-switch> 
    </div>

    <!-- <div v-if="number_pad == true">
      <dialer></dialer> 
      <dialer-switch></dialer-switch> 
    </div> -->
    
    <div v-if="callSubNav == 'quickconnects'">
      <quick-connects> </quick-connects>
      <!-- <dialer-switch></dialer-switch> -->
    </div>

    <div v-if="callSubNav == 'numberpad'">
      <number-pad></number-pad>
    </div>
   

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
import IncomingCall from "./components/IncomingCall.vue";
import NormalCall from "./components/NormalCall.vue";
// import Utilities from './components/Utilities.vue'
// import createContact from './components/CreateContact.vue'
import AfterCallWork from "./components/AfterCallWork.vue";
import ConferenceCall from "./components/ConferenceCall.vue";
import OnThirdPartyConnected from "./components/OnThirdPartyConnected.vue";
import Dialer from "./../Dialer";
import DialerSwitch from "./components/DialerSwitch.vue";
import QuickConnects from "./../QuickConnects";
import AddNotes from "./../AddNotes";
import NumberPad from "./../NumberPad";

export default {
  name: "Call",
  components: {
    IncomingCall,
    NormalCall,
    // Utilities,
    AfterCallWork,
    ConferenceCall,
    Dialer,
    QuickConnects,
    DialerSwitch,
    // createContact,
    AddNotes,
    OnThirdPartyConnected
  },
  data() {
    return {};
  },
  created() {
    // this.$store.dispatch("ticket/setTickets" , this.contact_attributes);
  },
  methods: {
    dialPadToggle() {
      this.$store.dispatch("common/setDialpadToogle");
    },
    redirectFcrmContact() {
      console.log("redirectFcrmContact clicked");
      var passData = {};
      passData.fcrmContactid = this.freshwork_crm_contact_id;
      passData.action = "VIEW_CONTACT";
      parent.postMessage(passData, "*");
    },
    redirectFcrmConversation() {
      console.log("redirectFcrmConversation clicked");
      var passData = {};
      passData.fcrmConversationId = this.freshchat_conversation_id;
      passData.freshchatAppId = this.freshchat_conversation_app_id;
      passData.action = "VIEW_CONVERSATION";
      parent.postMessage(passData, "*");
    },
  },
  computed: {
    ...mapGetters([
      "call_state",
      "contact_attributes",
      "outboundCall",
      "call_type",
      "callSubNav",
      "freshwork_crm_contact_id",
      "freshchat_conversation_app_id",
      "freshchat_conversation_id",
      "notes_editor",
      "number_pad",
    ]),
  },
};
</script>

<style scoped>
.bottom-actions {
  margin-top: auto;   /* 🔥 pushes to bottom */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  padding: 10px;
}
/* .dialpad-container-bottom {
  height: 40px;
  z-index: 1;
  background-color: #190f0f;
  box-shadow: 0 -2px 4px rgb(0 0 0 / 8%);
  border-radius: 4px 4px 0 0;
  position: absolute;
  width: 106%;
  margin-left: -10px;
  left: 0;
  bottom: 12px;
  background: #fff;
  text-align: center;
  padding: 9px;
  color: #3097e0;
} */
</style>
